import { render, staticRenderFns } from "./FolderOfferRemindDialog.vue?vue&type=template&id=36580988&scoped=true"
import script from "./FolderOfferRemindDialog.vue?vue&type=script&lang=js"
export * from "./FolderOfferRemindDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferRemindDialog.vue?vue&type=style&index=0&id=36580988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36580988",
  null
  
)

export default component.exports